import React, {
  forwardRef
} from "react";
import { cx } from "@linaria/core";
import { DefaultButton } from "./Button.styles";
export const Button = forwardRef(({
  size = "large",
  testId = "Button",
  className = "",
  mode,
  children,
  type = "button",
  ...restProps
}, ref) => /* @__PURE__ */ React.createElement(DefaultButton, {
  ref,
  "data-testid": testId,
  className: cx(className, mode && `${mode}-mode`, `${size}-size`),
  type,
  ...restProps
}, children));
export default Button;
